import { render, staticRenderFns } from "./lookCertificate.vue?vue&type=template&id=2a25b4ff"
import script from "./lookCertificate.vue?vue&type=script&lang=js"
export * from "./lookCertificate.vue?vue&type=script&lang=js"
import style0 from "./lookCertificate.vue?vue&type=style&index=0&id=2a25b4ff&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports